module.exports = __webpack_public_path__ + "static/img/u154.22900a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/figma/u154.png
// module id = SGUO
// module chunks = 0